module.exports = __webpack_public_path__ + "static/back-60704da713fc316856409bcce7f2a47d.jpg";